import React, { Component } from 'react';
import { Link } from "gatsby";

import { Row, Col, Card, ListGroup } from 'react-bootstrap';

import Layout from '../../Frame/Layout';
import { Helmet } from "react-helmet";
import favicon from '../../images/favicon.ico'

class Resources extends Component {
    render() {
        let description = "Get all the resources you need to be a better poker player here."
        let socialMediaTitle = "Various resources about poker by Edge.poker"
        let socialMediaDescription = description
        let socialMediaImageUrl = "https://edge.poker/pics/edge_logo_alt_white_bg.png"

        return (
            <Layout>
                <Helmet>
                    <title>Resources - Edge.Poker</title>
                    <meta name="description" content={description}/>
                    <meta name="keywords" content="poker resources, texas holdem resources"></meta>

                    <meta http-equiv="content-language" content="en-us"></meta>
                    
                    <meta name="twitter:card" content="summary"/>
                    <meta name="twitter:site" content="@EdgePokerApp"/>
                    <meta name="twitter:title" content={socialMediaTitle}/>
                    <meta name="twitter:description" content={socialMediaDescription}/>
                    <meta name="twitter:image" content={socialMediaImageUrl}/>
                
                    <meta name="og:type" content="website"/>
                    <meta name="og:title" content={socialMediaTitle}/>
                    <meta name="og:description" content={socialMediaDescription}/>
                    <meta name="og:image:secure" content={socialMediaImageUrl}/>
                    <meta name="og:url" content="https://app.edge.poker/hand-strength/"/>  
                    <script async defer src="/sl.js" type='text/javascript'/>
                    <link rel="preload" as="style" href="https://fonts.googleapis.com/css?family=Roboto&display=swap" onload="this.onload=null;this.rel='stylesheet'"></link>  
                    <link rel="icon" href={favicon} />
                </Helmet>

                <Row>
                    <Col xs="0" lg="2"></Col>
                    <Col xs="0" lg="8">
                        <Row>
                            <Col xs="12" className="mb-4 mt-4 text-center">
                                <h1 className="title">Resources</h1>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12" className="mb-3 mt-3">
                                <Card>
                                    <Card.Header>
                                        <h2>Articles</h2>
                                    </Card.Header>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <Link to="/resources/poker-hand-rankings">
                                                Poker Hand Rankings
                                            </Link>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Card>
                                
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12" className="mb-3 mt-3">
                                <Card>
                                    <Card.Header>
                                        <h2>External</h2>
                                    </Card.Header>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <a href="http://www.pokerology.com/lessons/math-and-probability/" target="_blank">
                                                Poker math
                                            </a>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <a href="https://poker.fandom.com/wiki/Texas_Hold%27Em_Top_10_Hands" target="_blank">
                                                Texas Hold'Em Top 10 Hands
                                            </a>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <a href="https://en.wikipedia.org/wiki/Texas_hold_%27em_starting_hands" target="_blank">
                                                Texas hold 'em starting hands
                                            </a>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <a href="https://en.wikipedia.org/wiki/Poker_strategy" target="_blank">
                                                Poker strategy
                                            </a>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Card>
                                
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="0" lg="2"></Col>
                </Row>
            </Layout>
        )
    }
}

export default Resources;